
const TokenKey = 'ACCESS_TOKEN'

export function getToken () {
  return localStorage.getItem(TokenKey)
}

export function setToken (token) {
  localStorage.setItem(TokenKey, token)
  return true
}

export function removeToken () {
  localStorage.removeItem(TokenKey)
  return true
}
